import React from 'react';
import _ from 'lodash'
import { api, config } from 'xadmin';
import { Icon } from 'xadmin-ui'
import { Button, Upload, message, Input } from 'antd';

const UploadFile = ({ input, title, url, accept, uploadData }) => {
  const [ loading, setLoading ] = React.useState(false)
  if (!url) return null

  const props = {
    name: 'license',
    multiple: true,
    showUploadList: false,
    headers: _.omit(api({ name: 'media' }).getHeaders(), 'Content-Type'),
    action: `${config('mediaUrl')}/core/license/upload`,
    onChange(info) {
      const { status } = info.file;
      if (status !== 'uploading') {
      }
      if (status === 'done') {
        message.success(info.file.name + info.file.response);
        uploadData()
      } else if (status === 'error') {
        message.error(info.file.name + info.file.response && info.file.response.file || '上传错误');
      }
    }
  }

  return (
    <Upload {...props} >
      <Button loading={loading}>
        <Icon type="upload" /> {title || '上传镜像'}
      </Button>
    </Upload>
  )
}

//上传文件并返回参数作为Value
const UploadFileInput = ({ input }) => {

  const [ loading, setLoading ] = React.useState(false)
  const [ inputValue, setInputValue ] = React.useState(null)

  const props = {
    name: 'file',
    action: api({ name: 'media' }).getHost() + ('core/media/' + inputValue),
    headers: _.omit(api({ name: 'media' }).getHeaders(), 'Content-Type')
  };

  const onChange = ({ file }) => {
    setLoading(true)
    if (file.status !== 'uploading') {
    }
    if (file.status === 'done') {
      setLoading(false)
      message.success(`${file.name} 上传成功`);
      const res = file.response
      res && res.url && input.onChange(res.url)
    } else if (file.status === 'error') {
      setLoading(false)
      message.error(`${file.name} 上传失败`);
    }
  }

  return (<>
    <Input
      value={inputValue}
      placeholder="存放目录名称"
      style={{ width: 140, marginRight: 10 }}
      onChange={(e) => setInputValue(e.target.value)}
    />

    <Upload {...props} onChange={onChange}>
      <Button disabled={!inputValue} loading={loading}>
        <Icon type="upload" /> 上传文件
      </Button>
    </Upload>
  </>
  )
}

export default UploadFile
export {
  UploadFileInput
}
